/* Marinelie — "Eintragen"-Sheet.
   Links mit data-ml-blur-nav oeffnen ein Fenster ueber die ganze Seite,
   Oben rechts schliesst ein X; Zurueck (auch die
   Wischgeste) schliesst ebenfalls. Vorher gab es kein Schliessen: wer
   aus der Instagram-Bio kam, sass im Fragebogen fest, weil die Adresse
   sich nicht aendert und Zurueck die Seite ganz verliess (Otton,
   19.10.2026).
   Der Inhalt wird per fetch geholt und injiziert — ein iframe scheitert
   an X-Frame-Options der Storefront. Ohne JS bleibt es ein Link. */
(function () {
  'use strict';

  /* Historisch: als iframe geladen? Chrome der Seite ausblenden. */
  if (window.self !== window.top) {
    document.documentElement.classList.add('ml-in-sheet');
  }

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var sheet = null;
  var inhalt = null;

  function bauen() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'ml-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'The Guestlist');

    inhalt = document.createElement('div');
    /* ml-gl-seite: Das Quiz bekommt im Fenster dieselbe feste Handy-Hoehe
       wie auf /pages/guestlist (ml-quiz-fest.css haengt an dieser Klasse).
       Ohne sie endete es mitten im Schirm, darunter Weiss und der Logo-Fuss
       des Fensters. Den Fuss gibt es deshalb nicht mehr (Otton 23.10.2026:
       "du hast es bis heute nicht geschafft diesen banner unten mit dem
       logo zu entfernen. der kommt jedes mal wenn man quiz oeffnet"). */
    inhalt.className = 'ml-sheet__inhalt ml-gl-seite';

    var zu = document.createElement('button');
    zu.type = 'button';
    zu.className = 'ml-sheet__zu';
    zu.setAttribute('aria-label', 'Schließen');
    zu.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16"/></svg>';
    zu.addEventListener('click', function () {
      /* Ueber die History schliessen, damit der Eintrag von oeffnen()
         nicht stehen bleibt und Zurueck spaeter ins Leere fuehrt. */
      if (history.state && history.state.mlSheet) history.back();
      else schliessen();
    });

    sheet.appendChild(zu);
    sheet.appendChild(inhalt);
    document.body.appendChild(sheet);
  }

  function schliessen() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    document.body.classList.remove('ml-blur-out');
    document.documentElement.classList.remove('ml-sheet-open');
  }

  function laden(href) {
    inhalt.innerHTML = '';
    /* ?start=1 (Quiz-Start auf der Startseite): das Quiz im Fenster
       springt gleich auf Frage 1, ml-duelle.js liest das Zeichen. */
    window.mlQuizDirekt = /[?&]start=1(&|$)/.test(href);
    fetch(href, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var main = doc.querySelector('#MainContent');
        inhalt.innerHTML = main ? main.innerHTML : '';
        /* Erst wenn der Inhalt steht und das Logo im Kopf geladen ist,
           blendet alles gemeinsam langsam ein. */
        var bilder = [];
        var kopfLogo = inhalt.querySelector('img');
        if (kopfLogo) bilder.push(kopfLogo);
        var offen = bilder.filter(function (b) { return !b.complete; }).length;
        function zeigenWennFertig() {
          offen -= 1;
          if (offen <= 0) {
            void sheet.offsetHeight;
            sheet.classList.add('is-geladen');
          }
        }
        if (!offen) {
          void sheet.offsetHeight;
          sheet.classList.add('is-geladen');
        } else {
          bilder.forEach(function (b) {
            if (b.complete) return;
            b.addEventListener('load', zeigenWennFertig, { once: true });
            b.addEventListener('error', zeigenWennFertig, { once: true });
          });
        }
        /* Section-Skripte erneut ausfuehren — injizierte <script> laufen nicht. */
        var srcs = [];
        (main || doc).querySelectorAll('script[src]').forEach(function (s) {
          if (srcs.indexOf(s.src) === -1) srcs.push(s.src);
        });
        srcs.forEach(function (src) {
          var n = document.createElement('script');
          n.src = src;
          n.addEventListener('load', function () { n.remove(); });
          document.body.appendChild(n);
        });
      })
      .catch(function () {
        /* Netz weg o. ae. — dann eben als normale Navigation. */
        window.location.href = href;
      });
  }

  function oeffnen(href) {
    bauen();
    sheet.classList.remove('is-geladen');
    laden(href);
    document.body.classList.add('ml-blur-out');
    document.documentElement.classList.add('ml-sheet-open');
    if (reduced()) sheet.classList.add('is-still');
    /* Erzwungener Reflow statt requestAnimationFrame — der laeuft in
       gedrosselten Tabs nicht, und dann bliebe das Sheet unten stehen. */
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
    /* Eigener History-Eintrag: Zurueck schliesst das Fenster statt die
       Seite zu verlassen. */
    try { history.pushState({ mlSheet: 1 }, ''); } catch (e) {}
  }

  function init() {
    document.querySelectorAll('[data-ml-blur-nav]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        var href = el.getAttribute('href');
        if (!href) return;
        event.preventDefault();
        oeffnen(href);
      });
    });

    window.addEventListener('popstate', function () { schliessen(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && sheet.classList.contains('is-open')) {
        if (history.state && history.state.mlSheet) history.back(); else schliessen();
      }
    });

    window.addEventListener('pageshow', function () {
      document.body.classList.remove('ml-blur-out');
      document.documentElement.classList.remove('ml-sheet-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
